export const tsmtWebinar = {
  seo: {
    title: "Bespire webinár TSMT® terapeutáknak · Július 20. és 23.",
    description:
      "Ingyenes 1 órás online webinár TSMT® terapeutáknak. A Bespire teljes körű AI asszisztens — brand, weboldal, blog/SEO, marketing, email, foglalás, CRM egy helyen. A webináron 3 területet mutatunk meg élőben.",
  },
  header: {
    cta: "Jelentkezem",
  },
  hero: {
    eyebrow: "Bespire × TSMT® · Ingyenes webinár",
    title: "Ismerd meg a Bespire-t — élő webinár TSMT® terapeutáknak",
    subtitle:
      "A Bespire teljes körű AI asszisztens szolgáltatóknak — brand, weboldal, blog/SEO, marketing, email, foglalás, CRM, csapat egy helyen. 1 óra alatt megmutatjuk élőben, hogyan viszi helyetted a napi munkát.",
    trust: ["Ingyenes", "Online, Zoom", "TSMT® terapeutáknak", "Kérdésekre is válaszolunk"],
    dates: [
      { label: "1. időpont", date: "Július 20. hétfő", time: "13:00 – 14:00" },
      { label: "2. időpont", date: "Július 23. csütörtök", time: "10:00 – 11:00" },
    ],
    datesNote: "Válaszd ki a neked megfelelőt a jelentkezéskor.",
    cta: "Jelentkezem a webinárra",
    ctaHint: "A jelentkezés a Google űrlapon néhány kattintás.",
  },
  testimonial: {
    title: "Így segít a Bespire Gonda Cilinek",
    subtitle: "Valódi ügyfél, valódi tapasztalat — nézd meg, hogyan változott meg a mindennapja.",
    videoAriaLabel: "Indítsd el az ügyfél interjú videót",
    playAriaLabel: "Videó lejátszása",
    quote: "A Bespire nem csak egy weboldal, ez a vállalkozói szabadságom kulcsa.",
    customerName: "Gonda Cili",
    customerRole: "Manuál terapeuta",
    customerCity: "Budapest",
    cta: "Jelentkezem a webinárra",
  },
  audience: {
    eyebrow: "Kinek szól",
    title: "Ha ezekben magadra ismersz, ez a webinár neked szól.",
    items: [
      {
        title: "Sok időt vesz el az egyeztetés",
        description: "Telefon, üzenet, naptár — három helyen követed, és néha kicsúsznak dolgok.",
      },
      {
        title: "Nincs átlátható online felületed",
        description: "Nincs saját oldalad, vagy van, de nem foglalható és nem tükrözi, amit valójában csinálsz.",
      },
      {
        title: "Kevés időd van marketingre",
        description: "Tudod, hogy kellene posztolni, hírlevelet küldeni — de gyakorlatban nem fér bele.",
      },
    ],
  },
  agenda: {
    eyebrow: "Agenda",
    title: "Miről lesz szó az 1 órában?",
    subtitle: "Röviden bemutatjuk, hogyan tudja a Bespire támogatni a mindennapi munkádat.",
    items: [
      {
        n: "01",
        title: "Mi az a Bespire, és miben segít a terapeutáknak?",
        description:
          "Rövid áttekintés arról, hogyan segít a teljes körű AI asszisztens a brand, weboldal, marketing, email, foglalás és CRM napi kezelésében.",
      },
      {
        n: "02",
        title: "Saját online jelenlét egyszerűen",
        description:
          "Hogyan lehet professzionális bemutatkozó oldalt, szolgáltatáslistát és foglalási felületet kialakítani technikai tudás nélkül.",
      },
      {
        n: "03",
        title: "Időpontok, érdeklődők és ügyfélfolyamatok kezelése",
        description:
          "Hogyan segíthet az AI asszisztens abban, hogy kevesebb manuális egyeztetésre és adminisztrációra legyen szükség.",
      },
      {
        n: "04",
        title: "AI-asszisztens a mindennapi munkában",
        description:
          "Hogyan tud az AI segíteni szövegírásban, kommunikációban, marketingben és a szolgáltatások érthetőbb bemutatásában.",
      },
      {
        n: "05",
        title: "TSMT® terapeutáknak elérhető kedvezményes lehetőség",
        description:
          "Bemutatjuk a TSMT® együttműködés keretében biztosított kedvezményes hozzáférést és a csatlakozás menetét.",
      },
      {
        n: "06",
        title: "Kérdések és válaszok",
        description:
          "A webinár végén lehetőség lesz konkrét kérdésekre, gyakorlati példákra és egyéni helyzetek átbeszélésére.",
      },
    ],
  },
  screenshots: {
    eyebrow: "Ezt fogod látni élőben",
    title: "Nem prezentáció — élő AI asszisztens, valódi felületek.",
    items: [
      {
        title: "Kész, foglalható bemutatkozó oldal",
        description:
          "AI chattel építed és módosítod. Nincs kódolás, nincs sablon-vadászat — leírod, mit szeretnél, és pár perc alatt kész az oldal.",
      },
      {
        title: "Átlátható foglalási naptár",
        description:
          "Órák, helyszínek, szünetek, ismétlődő időpontok — mind egy naptárban. Az AI asszisztens segít gyorsan felvinni és módosítani.",
      },
    ],
  },
  benefits: {
    eyebrow: "Amit megmutatunk",
    title: "Mit vált ki a Bespire a mindennapokban?",
    teaserLabel: "És még sok minden más",
    teaserMore: "…amit a webináron mutatunk meg élőben.",
    items: [
      { title: "Foglalás", description: "Online időpontfoglalás, automatikus emlékeztetők, lemondáskezelés." },
      { title: "Szolgáltatások bemutatása", description: "Egyéni, csoportos, otthoni feladat-csomagok — egy helyen, érthetően." },
      { title: "Online jelenlét", description: "Saját bemutatkozó oldal, saját domainen is, technikai tudás nélkül." },
      { title: "AI asszisztens", description: "Szövegek, posztok, hírlevelek, ügyfélkommunikáció — egy chatben." },
      { title: "Adminisztráció", description: "Számlázás, emlékeztetők, ügyféllisták — az AI asszisztensben." },
      { title: "\n", description: "\n" },
    ],
  },
  mockup: {
    eyebrow: "Példa",
    title: "Marketing terv, posztok és hirdetések — egy chatben.",
    subtitle: "Heti tartalom, Instagram / Facebook / TikTok posztok, hirdetések — az AI asszisztens megírja és ütemezi.",
    marketingTitle: "Marketing terv",
    marketingGoalLabel: "Cél",
    marketingGoal: "Új szülők elérése a nyári TSMT® foglalkozásokra",
    marketingChannelsLabel: "Csatornák",
    channels: ["Instagram", "Facebook", "TikTok"],
    marketingWeeklyLabel: "Heti terv",
    weeklyPlan: [
      { day: "Hétfő", content: "Ismeretős poszt: kinek segít a TSMT®" },
      { day: "Szerda", content: "Tipp-poszt: 3 játék otthonra" },
      { day: "Péntek", content: "Hirdetés: nyári foglalkozás ajánló" },
    ],
    marketingCta: "Hirdetés készítése",
    chat: {
      title: "AI asszisztens",
      user: "Írj egy Facebook hirdetést az új nyári TSMT® foglalkozásra.",
      ai: "Kész — 3 verzió: egy szülőknek szóló érzelmes, egy szakmai eredményeket említő, és egy rövid videós felirat. Célozzuk 25 km-re a várostól?",
    },
  },
  why: {
    eyebrow: "Miért érdemes részt venni",
    title: "Egy óra — átláthatóbb működés utána.",
    items: [
      "Konkrét, működő felületeket látsz, nem csak diákat.",
      "Kérdezhetsz — a végén Q&A blokk lesz.",
      "A jelentkezők utólag megkapják a felvételt.",
      "TSMT® terapeutaként külön kedvezményes csatlakozás vár rád.",
    ],
  },
  faq: {
    eyebrow: "GYIK",
    title: "Amit még tudni érdemes",
    items: [
      { q: "Mennyibe kerül a webinár?", a: "Ingyenes, TSMT® terapeutáknak szól." },
      { q: "Kell-e előre bármit tudni az AI asszisztensről?", a: "Nem. A webinárt úgy építjük fel, hogy kezdőknek is érthető legyen." },
      { q: "Lesz-e felvétel?", a: "Igen. A jelentkezők utólag megkapják a felvételt emailben." },
      { q: "Kell-e utána bármit fizetni vagy előfizetni?", a: "Nem. A webinár után döntesz, hogy szeretnéd-e kipróbálni. A TSMT®-s kedvezményről a webináron beszélünk." },
      { q: "Milyen platformon lesz?", a: "Zoom. A meetinglinket a jelentkezés után emailben küldjük." },
      { q: "Hogyan jelentkezhetek?", a: "A jelentkezem gombra kattintva egy rövid Google űrlapot kell kitöltened, és kiválasztanod az időpontot." },
    ],
  },
  closing: {
    title: "Foglald le a helyed a webinárra.",
    subtitle: "Két időpont közül választhatsz. Ingyenes, TSMT® terapeutáknak szól.",
    cta: "Jelentkezem a webinárra",
    ctaHint: "Google űrlap, kb. 30 másodperc.",
  },
  footer: {
    tagline: "Bespire × TSMT® — webinár terapeutáknak",
    contact: "Kérdésed van? zoltan@bespire.io",
  },
};
